import {
  ADD_ITEM_TO_CART,
  REMOVE_ITEM_FROM_CART,
  CLEAR_ITEMS_IN_CART,
  UPDATE_ITEMS_IN_CART,
  ADD_MULTIPLE_ITEMS_TO_CART
} from "../actions";
import { cartUpdated } from "../../utils/CommonFunctions";

const actionsForWhichTimeToUpdate = [
  ADD_ITEM_TO_CART,
  ADD_MULTIPLE_ITEMS_TO_CART,
  UPDATE_ITEMS_IN_CART,
  REMOVE_ITEM_FROM_CART
];

export default function cartItems(state = {}, action) {
  if (actionsForWhichTimeToUpdate.includes(action.type)) {
    cartUpdated();
  }

  let newState = { ...state };
  switch (action.type) {
    case ADD_ITEM_TO_CART: {
      let itemObj = action.payload;
      newState[itemObj.id] = itemObj;
      return { ...newState };
    }
    case ADD_MULTIPLE_ITEMS_TO_CART: {
      let { clearCart, newCart } = action.payload;
      if (clearCart) {
        return { ...newCart };
      }
      return { ...newState, ...newCart };
    }
    case UPDATE_ITEMS_IN_CART: {
      let itemObj = action.payload;
      const foodid = itemObj["id"];
      const itemQuantity = itemObj["itemQuantity"];
      if (newState[foodid]) {
        newState[foodid].quantity = itemQuantity;
      }
      return { ...newState };
    }
    case REMOVE_ITEM_FROM_CART: {
      let id = action.payload;
      delete newState[id];
      return { ...newState };
    }
    case CLEAR_ITEMS_IN_CART:
      localStorage.removeItem("cartExpiry");
      return {};
    default:
      return state;
  }
}



// WEBPACK FOOTER //
// ./src/store/reducers/cartItems.js